import { render, staticRenderFns } from "./Chusai.vue?vue&type=template&id=457f760c&scoped=true&"
import script from "./Chusai.vue?vue&type=script&lang=js&"
export * from "./Chusai.vue?vue&type=script&lang=js&"
import style0 from "./Chusai.vue?vue&type=style&index=0&id=457f760c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f760c",
  null
  
)

export default component.exports